import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SeOfficialNoteNew from "../../components/services/secondaryEducation/SeOfficialNoteNew";

const SEOfficialNoteNewPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.new`)}>
      <SeOfficialNoteNew />
    </PageWrapper>
  );
};

export default SEOfficialNoteNewPage;
